import React, { useContext, useEffect } from 'react';
import { useQuery } from 'react-query';
import toast from "react-hot-toast";
import { Link } from 'react-router-dom';
import Spinner from '../../../Component/Spinner/Spinner';
import { AuthContext } from '../../../Context/UseContext';
import { useDbUser } from '../../../hooks/useUser';

const MyOrders = () => {
    const { user, loading } = useContext(AuthContext);
    const [dbUser, isDbUserLoading] = useDbUser(user?.email);

    const { data: bookings = [], isLoading, refetch } = useQuery({
        queryKey: ['bookings'],
        queryFn: async () => {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/booking/${dbUser?.email}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            const data = await res.json();
            return data;
        }
    })

    useEffect(() => {
        refetch();
    }, [refetch, dbUser?.email]);

    const handleCancelOrder = (email, id, productId) => {
        if (window.confirm("Are you sure you want to cancel this order?")) {
            fetch(
                `${process.env.REACT_APP_API_URL}/products/booked/${email}/${id}/${productId}`,
                {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    if (data.success) {
                        toast.success("Booked Product Deleted Successfully");
                        refetch();
                    } else {
                        toast.error(data.error);
                    }
                });
        }
    };

    console.log(bookings)

    if (loading || isDbUserLoading || isLoading) return <Spinner />;

    return (
        <div>
            <h3 className="text-3xl mb-5">My Orders</h3>
            <div className=" w-full overflow-hidden rounded-lg shadow-xs">
                <table className="w-full whitespace-no-wrap">
                    <thead>
                        <tr className='text-xs font-semibold tracking-wide text-left text-gray-700 uppercase border-b dark:border-gray-700 bg-gray-300 dark:text-gray-400 dark:bg-black'>
                            <th className="px-4 py-3"></th>
                            <th className="px-4 py-3">Product Name</th>
                            <th className="px-4 py-3">price</th>
                            <th className="px-4 py-3">location</th>
                            <th className="px-4 py-3">phone</th>
                            <th className="px-4 py-3">Payment</th>
                            <th className="px-4 py-3">Cancel</th>
                        </tr>
                    </thead>
                    <tbody className='bg-white divide-y dark:divide-gray-700 dark:bg-gray-900'>
                        {bookings &&
                            bookings?.data?.map((booking, i) => <tr key={booking._id}>
                                <th className='px-4 py-3 text-sm'>{i + 1}</th>
                                <td className='px-4 py-3 text-sm font-semibold'>{booking.product}</td>
                                <td className='px-4 py-3 text-sm'>${booking.price}</td>
                                <td className='px-4 py-3 text-sm'>{booking.location}</td>
                                <td className='px-4 py-3 text-sm'>{booking.phone}</td>
                                <td className="px-4 py-3">
                                    {
                                        booking.price && !booking.paid && <Link
                                            to={`/dashboard/payment/${booking?._id}`}
                                        >
                                            <button
                                                className='btn btn-primary btn-sm'
                                            >Pay</button>
                                        </Link>
                                    }
                                    {
                                        booking.price && booking.paid && <span className='text-green-500'>Paid</span>
                                    }
                                </td>
                                <td className="px-4 py-3">
                                    <button
                                    className='btn btn-error btn-sm'
                                        onClick={() => handleCancelOrder(dbUser?.email, booking._id, booking.productID)}
                                    >
                                        Cancel Order
                                    </button>
                                </td>
                            </tr>)
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MyOrders;